import type {TypedObject} from '@portabletext/types'

/**
 * Every editable copy field in the CMS is a `richText` array (Portable Text).
 * Plain strings are still accepted so hard-coded page copy — and any document
 * that predates the rich-text migration — keeps rendering.
 */
export type RichTextValue = string | readonly TypedObject[] | null | undefined

/** True when the value carries any visible text. */
export function isRichText(value: RichTextValue): boolean {
  return plainText(value).trim().length > 0
}

/**
 * Flatten a rich-text value to a plain string. Use for contexts that cannot
 * carry markup: `aria-label`, `alt`, JSON-LD, meta descriptions.
 */
export function plainText(value: RichTextValue): string {
  if (!value) return ''
  if (typeof value === 'string') return value
  return value
    .map((block) => {
      const b = block as {_type?: string; children?: {text?: string}[]}
      if (b?._type !== 'block' || !Array.isArray(b.children)) return ''
      return b.children.map((child) => child?.text || '').join('')
    })
    .filter(Boolean)
    .join(' ')
}
